import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import { useState } from "react"

export interface UpdateListParams {
  listName: string
  id: string
}

export function useUpdateList() {
  const [isUpdateListLoading, setIsUpdateListLoading] = useState<boolean>(false)
  const request = useAxiosRequest()
  const updateList = async (uList: UpdateListParams) => {
    setIsUpdateListLoading(true)
    await request<any, UpdateListParams>({
      url: `${BASE_URL}/vesseltracking/list/single`,
      method: "PUT",
      data: uList,
    })
    setIsUpdateListLoading(false)
  }
  return { updateList, isUpdateListLoading }
}
